import React, { useState } from 'react';

export default function ThinkyIOTMobileFirstDesign({ onBack }) {
  const [devices] = useState([
    { id: 1, name: 'Operator Panel', type: 'Tablet', status: 'Active' },
    { id: 2, name: 'Field Dashboard', type: 'Mobile', status: 'Active' },
    { id: 3, name: 'Control Room', type: 'Desktop', status: 'Maintenance' },
  ]);

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg md:text-xl font-bold mb-6">Mobile-first Experience</h1>

      <p className="mb-6 text-blue-300">Optimized UX for operators, leaders, and field teams across mobile, tablet, and desktop devices.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {devices.map(device => (
          <div key={device.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <h3 className="text-lg font-semibold mb-2">{device.name}</h3>
            <p>Device Type: <span className="font-medium text-blue-400">{device.type}</span></p>
            <p>Status: <span className={`${device.status==='Active' ? 'text-green-400' : 'text-yellow-400'} font-semibold`}>{device.status}</span></p>
          </div>
        ))}
      </div>

      <section className="mt-8">
        <h2 className="text-lg font-semibold mb-3">Usage Summary</h2>
        <ul className="list-disc list-inside text-sm">
          <li>Total Devices: {devices.length}</li>
          <li>Active: {devices.filter(d => d.status==='Active').length}</li>
          <li>Under Maintenance: {devices.filter(d => d.status==='Maintenance').length}</li>
        </ul>
      </section>
    </div>
  );
}
